import mod from "-!./ContractForm.js?vue&type=script&lang=js&"; export default mod; export * from "-!./ContractForm.js?vue&type=script&lang=js&"